export default __webpack_public_path__ + "static/media/image2.2aa25b1a.jpg";